<template>
  <el-dialog
    :id="$options.name"
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="免费充电"
  >
    <el-form
      ref="params"
      :model="params"
      :rules="rules"
      label-width="auto"
      size="medium"
    >
      <el-form-item label="插座号" prop="socketNum">
        <el-row class="free" type="flex">
          <el-col
            v-for="(item, index) in records"
            :key="index"
            :span="6"
            :xs="8"
            class="card"
          >
            <div
              :class="{
                checked: index === checked,
                disabled: disabled(item.state),
              }"
              class="card-body"
              @click="select(index, item)"
            >
              <div>
                {{ item.socketNum
                }}<span v-if="freeVersions == '3'">{{
                  item.firstsd == "0" ? "A" : "B"
                }}</span>
              </div>
              <div>
                {{ disabled(item.state) === false ? "空闲" : "使用中" }}
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-row>
        <el-col :span="12" :xs="24">
          <el-form-item label="充电时长" prop="timeLen">
            <el-input-number
              v-model="params.timeLen"
              :min="0"
              placeholder="充电时长"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="24" style="height: 36px; line-height: 36px">
          为 0 是充满自停
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="freePost">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";

import maintainGetSocketStateById from "@/maintain/api/device/socket-manage/maintainGetSocketStateById";
import maintainCreatOrder from "@/maintain/api/fund/order-manage/maintainCreatOrder";

export default {
  name: "freeDialog",
  mixins: [dialogMixin, resDisposeMixin],
  props: {
    deviceId: Number,
    freeVersions: String,
  },
  watch: {
    dialog(newValue) {
      if (newValue === true) {
        this.checked = undefined;
        this.fetchData();
      }
    },
    deviceId(newValue) {
      this.params.deviceId = newValue;
      // eslint-disable-next-line vue/no-mutating-props
      this.deviceId = newValue;
    },
  },
  computed: {
    disabled() {
      return (state) => {
        return state !== "0";
      };
    },
    state() {
      return (state) => {
        return state === "0" ? "空闲" : "使用中";
      };
    },
  },

  data() {
    return {
      checked: undefined,
      records: [],
      rules: {
        socketNum: [{ required: true, message: "请选择插座号" }],
      },
      params: {
        deviceId: undefined,
        socketNum: undefined,
        timeLen: 0,
        ab: 0,
      },
    };
  },
  methods: {
    select(index, item) {
      if (item.state === "0") {
        this.checked = index;
        this.params.socketNum = item.socketNum;
        this.params.ab = item.firstsd;
      }
    },
    fetchData() {
      maintainGetSocketStateById({ id: this.deviceId }).then((res) => {
        this.records = res.data;
      });
    },
    freePost() {
      this.$refs["params"].validate((valid) => {
        if (valid) {
          this.loadStart();
          maintainCreatOrder(this.params)
            .then((res) => {
              this.resEditNoFetchDialog({ res });
            })
            .finally(() => {
              this.loadDialog.close();
            });
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.free
  flex-wrap: wrap
  text-align: center

  .card
    padding: 5px

    .card-body
      border: 2px solid #a0a0a0

  .checked
    border: 2px solid aqua !important

  .disabled
    border: 2px solid #ff6600 !important
</style>
